import './clientEnv';

const isProduction = () => window._MOKA_ENV_?.NODE_ENV === 'production';
const isOverseas = () => !!window._MOKA_ENV_?.IS_OVERSEAS;

const Raven = window.Raven;

const release = process.env.RELEASE_TAG;
/** 测试环境 */
let dsn = 'https://e309ae6fabfb46ef8ea36793803000a8@dev-sentry.mokahr.com/59';
/** 海外环境 */
if (isOverseas()) {
  dsn = 'https://a6a4d552909d2e59faefb3bda7fb0083@sentry-sg.mokahr.com/36';
} else if (isProduction()) {
  /** 国内生产环境 */
  dsn = 'https://5e32135313654782a049ba32cbf7ed45@sentry-fe.mokahr.com/100';
}

if (Raven) {
  if (release) {
    Raven.config(dsn, { release }).install();
  } else {
    Raven.config(dsn).install();
  }

  window.onunhandledrejection = function unhandledRejectionSentryHandler(evt) {
    if (evt instanceof Error) {
      return Raven.captureException(evt);
    }
    const reason = evt.reason || evt?.detail?.reason;

    if (reason) {
      Raven.captureException(reason);
    }
  };

  Raven.setUserContext(window.MOKA_USER || {});
}
